<template>
  <div>
    <v-dialog v-model="showEmail" max-width="1000">
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="info" class="text-capitalize font-weight-regular" block depressed dark v-on="on">Compose</v-btn>
      </template> -->
      <v-card dark class="theme-bg-card-5">
        <v-card-text>
                <v-flex>
                    <v-toolbar-title>
                      <br />
                <v-avatar size="60">
                  <img src="@/assets/EmailIcon.png" />
                </v-avatar>
                Compose Email
              </v-toolbar-title>

              <v-spacer></v-spacer> 
          
                </v-flex>
            <!-- <div class="d-flex align-center pa-3">
              <h3>Compose Email</h3>
            </div> -->
          <v-divider></v-divider>
          <div style="margin-top:1rem">
            <form>
              <v-row>
                <v-col cols="12">
                  To: 
                  <v-text-field placeholder="To" v-model="to" filled background-color="transparent"></v-text-field>
                </v-col>
                <v-col cols="12">
                  Subject:
                  <v-text-field placeholder="Subject" v-model="subject" filled background-color="transparent"></v-text-field>
                </v-col>
                <v-col cols="12">
                  Message:
                  <v-textarea placeholder="Type a message" v-model="message" filled rows="3" background-color="transparent"></v-textarea>
                </v-col>
              </v-row>
              <div class="text-right">
                <v-btn text color="error" @click="showEmail = !showEmail">close </v-btn>
                <v-btn color="info" @click="sendMail()">
                  Send
                  <v-icon small class="ml-2">mdi-send</v-icon>
                </v-btn>
              </div>
            </form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'GmailCompose',
  props: ['showEmail'],
  data: () => ({
    message: '',
    subject: '',
    to: 'john@macheenist.com',
    selected: [],
    focus: {
      subject: true,
      message: false,
    },
    isClass: true,
    SpeechRecognition: null,
    recognition: null,
  }),
  mounted() {
    let profile = JSON.parse(localStorage.getItem('currentUser'));
    this.userInfo = profile;
    window.gapi.load('client', this.initializeGapiClient);
    this.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    this.recognition = new window.webkitSpeechRecognition();
    this.recognition.continuous = true;
    this.recognition.interimResults = true;
    this.recognition.lang = 'en-US';

    var finalTranscripts = '';
    let _self = this;
    this.recognition.onresult = function(event) {
      console.log(event.results);
      var interimTranscripts = '';
      for (var i = event.resultIndex; i < event.results.length; i++) {
        var transcript = event.results[i][0].transcript;
        transcript.replace('\n', '<br>');
        if (event.results[i].isFinal) {
          finalTranscripts += transcript;
        } else {
          interimTranscripts += transcript;
        }
        if (_self.focus.subject) {
          _self.subject = finalTranscripts + interimTranscripts;
        } else {
          if (!_self.focus.message) {
            _self.focus.message = true;
            finalTranscripts = '';
          }

          _self.message = finalTranscripts + interimTranscripts;
        }
      }
    };
    this.recognition.onerror = function(event) {
      console.log('Error', event);
    };
  },
  methods: {
    async initializeGapiClient() {
      console.log('Init Google Client');
      await window.gapi.client.init({
        apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
        discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest', 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
      });
      let tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        scope: 'https://mail.google.com/',
        callback: '', // defined later
      });
      tokenClient.callback = async (resp) => {
        if (resp.error !== undefined) {
          throw resp;
        }
      };
      if (window.gapi.client.getToken() === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({ prompt: '' });
      }
      this.readOutLoud('Subject:');
      
      this.recognition.start();
      setTimeout(() => {
        this.focus.subject = false;
        
        this.readOutLoud('Message:');  
      }, 10000);
    },
    sendMail() {
      this.userInfo = JSON.parse(localStorage.getItem('currentUser'));
      const encodedMail = btoa(
        [
          `Content-Type: multipart/mixed; boundary="foo_bar_baz"\r\n`,
          `MIME-Version: 1.0\r\n`,
          `To: ${this.to}\r\n`,
          `Subject: ${this.subject} \r\n\r\n`,
          `--foo_bar_baz\r\n`,
          `Content-Type: text/plain; charset="UTF-8"\n`,
          `MIME-Version: 1.0\n`,
          `Content-Transfer-Encoding: 7bit\n`,
          `Hello There\n\n ${this.message} \r\n\r\n`,
          `\n\nRegards\n`,
          ` ${this.userInfo.name}\n`,
          `\n\nFrom Cogneetiv AI\n`,
          `--foo_bar_baz--`,
        ].join('')
      )
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
      const request = window.gapi.client.gmail.users.messages.send({
        userId: 'me',
        resource: {
          raw: encodedMail,
        },
      });
      request.execute(() => {
        console.log('Send Email');
        this.showEmail = false;
        this.readOutLoud('Email Sent');
      });
    },
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

     speech.onend = function() {
      setTimeout(() => {
      Event.$emit('speakModeOn');
      }, 3200);
     };
    },
  },
};
</script>
<style scoped src="../components/css/Style.css">

</style>